import { Flex, FlexProps } from '@chakra-ui/react'
import BillingTransitionBanner from '../components/UI/BillingTransitionBanner'
import SubscripitonIndicator from '../components/UI/SubscriptionIndicator'
import TourGuide from '../components/UX/TourGuide'
import { useAuthContext } from 'context/AuthProvider'
import { useIsSubscribed } from 'hooks'
import * as React from 'react'
import { Helmet } from 'react-helmet'

type PageWrapProps = FlexProps & {
  title: string
  inline?: boolean
}

const PageWrap = React.forwardRef<HTMLDivElement, PageWrapProps>(
  ({ children, title, inline, ...rest }, ref) => {
    const {
      isSubscribed,
      loading,
      subscriptionStatus,
      cancelAtPeriodEnd,
      isManual,
      billingInformationCompleted
    } = useIsSubscribed()
    const { isAuthenticated } = useAuthContext()

    const showBanner =
      billingInformationCompleted &&
      (!isSubscribed || cancelAtPeriodEnd) &&
      isAuthenticated &&
      !inline &&
      !loading &&
      !isManual

    const showGuide =
      (isAuthenticated && !inline && billingInformationCompleted) || (isManual && isAuthenticated)
    return (
      <>
        <Helmet>
          <title>{title}</title>
        </Helmet>
        {showGuide && <TourGuide />}
        <Flex {...rest} ref={ref}>
          {/* The 1 Sept 2026 billing/analytics notice. Shown on every
              authenticated page (it is dismissible except on analytics and
              settings) and independent of subscription state, because the
              card-details ask applies to every account — including the manual
              and already-subscribed ones the warning banner below skips. */}
          {isAuthenticated && !inline && <BillingTransitionBanner />}
          {showBanner ? (
            <SubscripitonIndicator
              status={subscriptionStatus}
              cancelAtPeriodEnd={cancelAtPeriodEnd}
            />
          ) : (
            <></>
          )}
          {children}
        </Flex>
      </>
    )
  }
)

PageWrap.defaultProps = {
  flex: 1,
  bg: 'background.100',
  pt: { base: 'calc(56px + 0.75rem)', md: 'calc(60px + 1rem)' },
  px: { base: 3, sm: 4, md: 0 },
  height: '100%',
  flexDir: 'column',
  align: 'flex-start',
  justify: 'flex-start',
  inline: false
}

export default PageWrap
